import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPagePalmaDeMallorca = props => {
  return (
    <CityLandingPage
      cityKey="PalmaDeMallorca"
      cityLabel="palmaDeMallorca"
      cityConfig={cityContent.palmaDeMallorca}
      {...props}
    />
  );
};

export default LandingPagePalmaDeMallorca;
